const CHUNK_RECOVERY_STORAGE_KEY_PREFIX = 'chattenger:web:chunk-recovery';

const toErrorMessage = (error: unknown) => {
    if (error instanceof Error) {
        return `${error.name} ${error.message}`.trim();
    }

    return String(error || '');
};

export const isChunkLoadFailure = (error: unknown) => {
    const message = toErrorMessage(error);

    return (
        message.includes('ChunkLoadError') ||
        message.includes('Failed to load chunk') ||
        (message.includes('/_next/static/chunks/') && message.toLowerCase().includes('failed'))
    );
};

export const getChunkRecoveryStorageKey = (buildMarker: string | undefined) =>
    `${CHUNK_RECOVERY_STORAGE_KEY_PREFIX}:${String(buildMarker || 'unknown').trim() || 'unknown'}`;

export const shouldAttemptChunkRecovery = ({
    error,
    buildMarker,
    sessionStorage,
}: {
    error: unknown;
    buildMarker?: string;
    sessionStorage: Pick<Storage, 'getItem' | 'setItem'> | null;
}) => {
    if (!isChunkLoadFailure(error)) {
        return false;
    }

    if (!sessionStorage) {
        return false;
    }

    const storageKey = getChunkRecoveryStorageKey(buildMarker);

    if (sessionStorage.getItem(storageKey) === '1') {
        return false;
    }

    sessionStorage.setItem(storageKey, '1');
    return true;
};

export const recoverChunkLoadFailure = ({
    error,
    buildMarker,
    browserWindow,
}: {
    error: unknown;
    buildMarker?: string;
    browserWindow: {
        location: {
            reload: () => void;
        };
        sessionStorage: Pick<Storage, 'getItem' | 'setItem'>;
    } | null;
}) => {
    if (
        !shouldAttemptChunkRecovery({
            error,
            buildMarker,
            sessionStorage: browserWindow?.sessionStorage ?? null,
        })
    ) {
        return false;
    }

    browserWindow?.location.reload();
    return true;
};
